import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import moment from 'moment';
import LandmanPayInfo from 'src/models/personnel/LandmanPayInfo';

interface IDefaultPayHistoryDialogProps {
    dialogName: string;
    defaultPayHistory: Array<LandmanPayInfo>;
    hideDialog: () => void;
}

const DefaultPayHistoryDialog = (props: IDefaultPayHistoryDialogProps) => {
    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('DefaultPayHistoryDialog onCreate()', props.defaultPayHistory);
    };

    const OKClicked = () => {
        props.hideDialog();
    };

    const getPayByValue = (value: string) => {
        switch (value) {
            case 'D':
                return 'Day';
            case 'H':
                return 'Hour';
            case 'M':
                return 'Month';
            default:
                return 'Unknown';
        }
    };

    return (
        <Dialog title="Default Pay Rate History" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{maxHeight: '75%', width: '65%' }}>
            {props.defaultPayHistory?.length > 0 && <div>
                <div style={{ overflowY: 'scroll', maxHeight: '25rem' }}>
                    <table style={{ width: '100%' }}>
                        <thead>
                            <tr style={{background: '#d6d6d6'}}>
                                <th style={{ width: '10%' }}>Pay By</th>
                                <th style={{ width: '15%' }}>Pay Rate</th>
                                <th style={{ width: '15%' }}>Eff Date</th>
                                <th style={{ width: '10%' }}>Manager</th>
                                <th style={{ width: '25%' }}>Manager Name</th>
                                <th style={{ width: '10%' }}>Prev Pay By</th>
                                <th style={{ width: '15%' }}>Prev Pay Rate</th>
                            </tr>
                        </thead>
                        {props.defaultPayHistory?.map((pay: LandmanPayInfo, index: number) => {
                            return (
                                <tbody key={index}>
                                    <tr className={`contract-pay-history-active-item-${index}`}>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {parseFloat(pay.payRate?.toString()).toFixed(2)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {getPayByValue(pay.payUnit)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {moment(pay.effDate).format('YYYY-MM-DD') as unknown as Date}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {pay.mgrNo}
                                        </td>
                                        <td style={{ width: '25%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {pay.tsdUser}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {getPayByValue(pay.prevUnit)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {parseFloat(pay.prevRate?.toString()).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                </div>
            </div>}
            {(!props.defaultPayHistory || props.defaultPayHistory.length === 0) && (
                <div className="bold-centered">No Default Pay History</div>
            )}
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center', textAlign: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => OKClicked()}
                />
            </div>
        </Dialog>
    );
};

export default DefaultPayHistoryDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/pay/DefaultPayHistoryDialog.tsx